import { format, isValid, parse } from 'date-fns';

export function formatIsoDateOnly(d: Date): string {
  return format(d, 'yyyy-MM-dd');
}

export function parseDateOnlyLocal(
  value: string | null | undefined,
): Date | null {
  if (!value) return null;
  const date = parse(value, 'yyyy-MM-dd', new Date());
  return isValid(date) ? date : null;
}

export function toUtcSecondsIso(date: Date): string {
  return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
}

export function toLocalIsoNoTimezone(date: Date): string {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss");
}

export function toLocalIsoWithOffset(date: Date): string {
  return format(date, "yyyy-MM-dd'T'HH:mm:ssxxx");
}

export function areSameYearAndMonth(first: Date, second: Date): boolean {
  return (
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth()
  );
}

export function removeDayFromFormat(format?: string): string | undefined {
  if (!format) {
    return undefined;
  }

  return format
    .replace(/[-/\s]?\b(d{1,2})/g, '')
    .replace(/(\w{4})(\w{2})\w{2}/, '$1$2')
    .replace(/^(\.)(.*)$/, '$2')
    .replace(/^(\/)(.*)$/, '$2')
    .replace(/^(-)(.*)$/, '$2')
    .replace(/\s+,/, ',')
    .trim();
}
